import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { id: "update-request-modal" }
const _hoisted_2 = { class: "close" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = { class: "details-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "details user-details"
}
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { class: "email" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "details dog-details"
}
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "weight" }
const _hoisted_14 = { class: "size" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "details contract-details" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "details contract-details" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 4,
  class: "details trainer-details"
}
const _hoisted_23 = { class: "date" }
const _hoisted_24 = ["min"]
const _hoisted_25 = { class: "trainer" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "length" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 5,
  class: "details trainer-details"
}
const _hoisted_30 = { class: "date" }
const _hoisted_31 = {
  key: 0,
  class: "date-okay"
}
const _hoisted_32 = { class: "date" }
const _hoisted_33 = {
  key: 1,
  class: "date-okay"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "details" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "details" }
const _hoisted_39 = {
  key: 0,
  class: "price"
}
const _hoisted_40 = {
  key: 1,
  class: "price"
}
const _hoisted_41 = { class: "errors" }
const _hoisted_42 = {
  key: 0,
  class: "error-info"
}
const _hoisted_43 = {
  key: 1,
  class: "error-info"
}
const _hoisted_44 = { class: "buttons" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $setup.CloseIcon,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, _hoisted_3)
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.loadingText || $setup.requestStore.requestStatus || "Submitting..."), 1))
      : _createCommentVNode("", true),
    _createElementVNode("h3", null, _toDisplayString($setup.Events.EventTypeMap[$setup.workingRequest.eventType]) + _toDisplayString('trainingType' in $setup.workingRequest ? `: ${$setup.workingRequest.trainingType}` : null), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", { src: $setup.PersonIcon }, null, 8, _hoisted_6),
      ($setup.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["name", {'red': !$setup.deducedName}])
            }, _toDisplayString($setup.deducedName || "Unknown Name"), 3),
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.user.phone || "Unknown Number"), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.user.email), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", { src: $setup.PetIcon }, null, 8, _hoisted_10),
      ($setup.dog)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString($setup.dog.name), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.dog.weight), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.dog.size), 1)
          ]))
        : _createCommentVNode("", true),
      ($setup.workingRequest.eventType === $setup.Events.EventType.Training)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("img", { src: $setup.ContractIcon }, null, 8, _hoisted_15),
            _createElementVNode("div", _hoisted_16, [
              (!$setup.agreements.isAgreementsReady)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Loading Contract..."))
                : ($setup.requestContract)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openDocusignEnvelope($setup.requestContract.$id, $setup.requestContract.dsEnvelopeStatus)))
                    }, "View Contract"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_18, "Unable to locate contract associated with this request"))
            ])
          ], 64))
        : _createCommentVNode("", true),
      ($setup.workingRequest.eventType === $setup.Events.EventType.Training)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("img", { src: $setup.DiscountIcon }, null, 8, _hoisted_19),
            _createElementVNode("div", _hoisted_20, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "What discount is applied?", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "info",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.discountPercent) = $event)),
                placeholder: "Select a discount amount"
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("option", { value: "0" }, "No discount", -1),
                _createElementVNode("option", { value: "5" }, "5% (Multiple dogs)", -1),
                _createElementVNode("option", { value: "10" }, "10% (Veteran)", -1),
                _createElementVNode("option", { value: "15" }, "15% (Both)", -1)
              ]), 512), [
                [_vModelSelect, $setup.discountPercent]
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("img", { src: $setup.CalendarIcon }, null, 8, _hoisted_21),
      ($setup.workingRequest.eventType === $setup.Events.EventType.Training)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.inputDate) = $event)),
                type: "date",
                name: "dateSelector",
                min: $setup.today
              }, null, 8, _hoisted_24), [
                [_vModelText, $setup.inputDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[18] || (_cache[18] = _createTextVNode("Trainer")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedTrainer) = $event)),
                class: _normalizeClass({missing: $setup.selectedTrainer === null})
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "Select a Trainer", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.trainerStore.trainers.values(), (trainer) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: trainer.$id,
                    value: trainer.$id
                  }, _toDisplayString(trainer.nickname), 9, _hoisted_26))
                }), 128))
              ], 2), [
                [_vModelSelect, $setup.selectedTrainer]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[19] || (_cache[19] = _createTextVNode("Length (weeks)")),
              _createElementVNode("div", {
                class: _normalizeClass(["button-container", {missing: $setup.eventLength === null}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableWeeks, (i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: `index-${i}`,
                    class: _normalizeClass({selected: $setup.eventLength === i}),
                    onClick: ($event: any) => ($setup.eventLength = i, $setup.getPrice())
                  }, _toDisplayString(i), 11, _hoisted_28))
                }), 128))
              ], 2)
            ])
          ]))
        : ($setup.workingRequest.eventType === $setup.Events.EventType.Boarding)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _cache[22] || (_cache[22] = _createElementVNode("label", null, "Start Date/Time", -1)),
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.inputDate) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, $setup.inputDate]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.boardingStartTime) = $event)),
                  type: "time"
                }, null, 512), [
                  [_vModelText, $setup.boardingStartTime]
                ])
              ]),
              ($setup.workingRequest.companyPickup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      id: "pickupOkay",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.boardingStartOkay) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, $setup.boardingStartOkay]
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("label", { for: "pickupOkay" }, "Company pickup okay?", -1))
                  ]))
                : _createCommentVNode("", true),
              _cache[23] || (_cache[23] = _createElementVNode("label", null, "End Date/Time", -1)),
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.boardingEndDate) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, $setup.boardingEndDate]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.boardingEndTime) = $event)),
                  type: "time"
                }, null, 512), [
                  [_vModelText, $setup.boardingEndTime]
                ])
              ]),
              ($setup.workingRequest.companyDropoff)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      id: "dropoffOkay",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.boardingEndOkay) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, $setup.boardingEndOkay]
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("label", { for: "dropoffOkay" }, "Company dropoff okay?", -1))
                  ]))
                : _createCommentVNode("", true),
              ($setup.workingRequest.endTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "(" + _toDisplayString($setup.ScheduleRequest.eventLengthNights($setup.workingRequest)) + " Nights)", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("img", { src: $setup.PriceIcon }, null, 8, _hoisted_35),
      _createElementVNode("div", _hoisted_36, [
        _withDirectives(_createElementVNode("input", {
          id: "useEquipPrice",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.useEquipPrice) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, $setup.useEquipPrice]
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("label", { for: "useEquipPrice" }, "Add Equipment Fee ($350)", -1))
      ]),
      _createElementVNode("img", { src: $setup.PriceIcon }, null, 8, _hoisted_37),
      _createElementVNode("div", _hoisted_38, [
        ($setup.workingRequest.eventType === $setup.Events.EventType.Training && $setup.eventLength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Price: $ " + _toDisplayString($setup.price) + ".00", 1))
          : _createCommentVNode("", true),
        ($setup.workingRequest.eventType === $setup.Events.EventType.Boarding)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Price: $ " + _toDisplayString($setup.price) + ".00", 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          id: "useCustomPrice",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.useCustomPrice) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, $setup.useCustomPrice]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("label", { for: "useCustomPrice" }, "Use Custom Price?", -1)),
        ($setup.useCustomPrice)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 2,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.customPrice) = $event)),
              type: "number",
              min: "1"
            }, null, 512)), [
              [_vModelText, $setup.customPrice]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 3,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.estimatedPrice) = $event)),
              disabled: "",
              type: "input"
            }, null, 512)), [
              [_vModelText, $setup.estimatedPrice]
            ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_41, [
      (!$setup.deducedName)
        ? (_openBlock(), _createElementBlock("li", _hoisted_42, "User does not have a name. Please have them set their name in the customer portal."))
        : _createCommentVNode("", true),
      ($setup.error)
        ? (_openBlock(), _createElementBlock("li", _hoisted_43, _toDisplayString($setup.error), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("button", {
        disabled: $setup.loading,
        onClick: $setup.declineRequest
      }, "Decline", 8, _hoisted_45),
      _createElementVNode("button", {
        disabled: !$setup.isValid || $setup.loading,
        onClick: $setup.acceptRequest
      }, "Submit", 8, _hoisted_46)
    ])
  ]))
}